import React, { Component } from 'react';
import classNames from 'classnames';

import { firebaseDB } from '../firebase';


class ContactForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            email: '',
            phone: '',
            eventDate: '',
            eventPlace: '',
            text: '',
            alert: null,
            validated: false
        }
    }

    showSuccess(text) {
        return (
            <div className="alert alert-success alert-dismissible">
                <button type="button" className="close" onClick={() => this.setState({ alert: null })}><span aria-hidden="true">&times;</span></button>
                <i className="fa fa-lg fa-thumbs-o-up"></i> {text}
            </div>
        );
    }

    showError(text) {
        return (
            <div className="alert alert-danger alert-dismissible">
                <button type="button" className="close" onClick={() => this.setState({ alert: null })}><span aria-hidden="true">&times;</span></button>
                <i className="fa fa-lg fa-warning"></i> {text}
            </div>
        );
    }

    validate(value) {
        if (value) {
            return true
        }
        return false;
    }

    validateForm(e) {
        this.setState({
            validated: true
        });

        const validate = this.validate;

        return validate(this.state.name) && validate(this.state.email) && validate(this.state.text);
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    onSubmit(e) {
        e.preventDefault();

        if (!this.validateForm(e)) {
            this.setState({
                alert: this.showError("Uzupełnij brakujące pola w formularzu i wyślij ponownie.")
            });
            return;
        }

        const contactDBRef = firebaseDB.ref('/forms/contact');

        let newContact = contactDBRef.push();

        newContact.set({
            createdAt: Date.now(),
            name: this.state.name,
            email: this.state.email,
            phone: this.state.phone,
            eventDate: this.state.eventDate,
            eventPlace: this.state.eventPlace,
            text: this.state.text,
            hop: 0
        }).then((success) => {
            this.setState({
                name: "",
                email: "",
                phone: "",
                eventDate: "",
                eventPlace: "",
                text: "",
                alert: this.showSuccess("Dziękujemy, wkrótce odpowiemy na Twoją wiadomość!"),
                validated: false
            });
        }).catch((error) => {
            console.error(error);
            this.setState({
                alert: this.showError("Niestety coś poszło nie tak, spróbuj ponownie za chwilę.")
            });
        });
    }

    render() {
        const validate = this.validate;

        let nameClass = classNames({
            'form-group': true,
            'has-error': this.state.validated && !validate(this.state.name)
        });

        let emailClass = classNames({
            'form-group': true,
            'has-error': this.state.validated && !validate(this.state.email)
        });

        let phoneClass = classNames({
            'form-group': true
        });

        let eventDateClass = classNames({
            'form-group': true
        });

        let eventPlaceClass = classNames({
            'form-group': true
        });

        let textClass = classNames({
            'form-group': true,
            'has-error': this.state.validated && !validate(this.state.text)
        });

        let nameHelpClass = classNames("help-block", { "hidden": !(this.state.validated && !validate(this.state.name)) });
        let emailHelpClass = classNames("help-block", { "hidden": !(this.state.validated && !validate(this.state.email)) });
        let textHelpClass = classNames("help-block", { "hidden": !(this.state.validated && !validate(this.state.text)) });

        return (
            <form name="contact" className="contact-comments" onSubmit={this.onSubmit.bind(this)} >
                {this.state.alert ? this.state.alert : null}
                <div className="row">
                    <div className="col-md-6 ">
                        <div className={nameClass}>
                            <input type="text" name="name" value={this.state.name} onChange={this.onChange.bind(this)} className=" form-control" placeholder="Imię i nazwisko *" maxLength="100" required="" />
                            <span className={nameHelpClass}>To pole jest wymagane, uzupełnij je.</span>
                        </div>
                        <div className={emailClass}>
                            <input type="email" name="email" value={this.state.email} onChange={this.onChange.bind(this)} className=" form-control" placeholder="Email *" maxLength="100" required="" />
                            <span className={emailHelpClass}>Uzupełnij to pole lub upewnij się, że adres email jest poprawny.</span>
                        </div>
                        <div className={phoneClass}>
                            <input type="tel" name="phone" value={this.state.phone} onChange={this.onChange.bind(this)} className=" form-control" placeholder="Telefon" maxLength="100" />
                        </div>
                    </div>
                    <div className="col-md-6 form-group">
                        <div className={eventDateClass}>
                            <input type="text" name="eventDate" value={this.state.eventDate} onChange={this.onChange.bind(this)} className=" form-control" placeholder="Data wydarzenia" maxLength="100" required="" />
                        </div>
                        <div className={eventPlaceClass}>
                            <input type="text" name="eventPlace" value={this.state.eventPlace} onChange={this.onChange.bind(this)} className=" form-control" placeholder="Miejsce wydarzenia" maxLength="100" required="" />
                        </div>
                        <div className={textClass}>
                            <textarea name="text" value={this.state.text} onChange={this.onChange.bind(this)} className="cmnt-text form-control" placeholder="Wiadomość *" maxLength="400"></textarea>
                            <span className={textHelpClass}>To pole jest wymagane, uzupełnij je.</span>
                        </div>
                        <div className="form-group full-width">
                            <button type="submit" className="btn btn-small btn-dark-solid ">Wyślij</button>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default ContactForm;


// WEBPACK FOOTER //
// ./src/contact/ContactForm.js